class ProductTooltipOpen extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (e) => {
      document.querySelector('product-tooltip').classList.add('open');
    })
  }

}

customElements.define('product-tooltip-open', ProductTooltipOpen);




class ProductTooltip extends HTMLElement {
  constructor() {
    super();
    this.querySelector('.closer').addEventListener('click', (e) => {
      document.querySelector('product-tooltip').classList.remove('open');
    })
  }

}

customElements.define('product-tooltip', ProductTooltip);